import { Divider, Stack } from '@chakra-ui/react';
import * as React from 'react';

import { Card } from '@/imports/ui/chakra/components/Card';

export const CardDividerList: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <Card p="6">
    <Stack spacing="2" divider={<Divider />}>
      {children}
    </Stack>
  </Card>
);
